// extracted by mini-css-extract-plugin
module.exports = {"header":"AuthHeader_header__7Uky5","content":"AuthHeader_content__yPXFw","logo":"AuthHeader_logo__3XeOZ"};